export enum MemberSignupStep {
    Basic = 1,
    EmployerDetails = 2,
    PersonalDetails = 3,
    PackageDetails = 4,
    PaymentDetails = 5,
    SignUpComplete = 6,
}